var $window = $(window);
$(function () {
  var ww = $window.width(); // ウインドウの幅
  var wh = $window.height(); // ウィンドウの高さ
  var ws = $window.scrollTop(); // スクロール位置
  var $videoWrap = $('.rec_topImage'); // 動画の外枠
  var $video = $('.topVideo'); // 動画本体
  var $animationWraps = $('.js-animation'); // スクロールでアニメーションをするオブジェクト

  videoResize(ww, wh, $videoWrap, $video); // 動画の大きさを決める関数を実行

  // リサイズ時の処理
  $window.on('resize scroll', $.throttle(250, function () {
    // 値の上書き
    ww = $(this).width();
    wh = $(this).height();
    ws = $window.scrollTop();
    // 関数実行
    videoResize(ww, wh, $videoWrap, $video);
    addAnimationClass($animationWraps, wh, ws);
  }));
});

// 動画の大きさを決める関数
function videoResize (ww, wh, $videoWrap, $video) {
  if (ww >= 1024) {
    wh = wh - 120 - 40;
  } else if (ww >= 480) {
    wh = wh - 60 - 40;
  } else {
    wh = wh - 60 - 25;
  }
  $videoWrap.height(wh);

  if (ww / wh > 16 / 9) {
    $video.css({
      width: '100%',
      height: 'auto'
    });
  } else {
    $video.css({
      width: 'auto',
      height: '100%'
    });
  }
}

// 読み込み時の処理
$window.on('load', function (e) {
  // 動画の上の文字とページタイトルの文字を表示させる
  $('.topCopy_row').css({
    transform: 'scaleX(1)'
  });
  var $headAnimEls = $('.topCopy_row span');
  var l = $headAnimEls.length;
  var i = 0;
  var timer = setInterval(function () {
    $headAnimEls.eq(i).css({
      opacity: 1,
      transform: 'translateY(0) scale(1)'
    });
    i++;
    if (i == l) {
      clearInterval(timer);
    }
  }, 50);

  // スクロールのアニメーションを表示させる
  var $animationWraps = $('.js-animation'); // スクロールでアニメーションをするオブジェクト
  var ws = $(this).scrollTop(); // 読み込み時のスクロール位置
  var wh = $(this).height(); // ウィンドウの高さ
  addAnimationClass($animationWraps, wh, ws);
});

// アニメーション用の関数
function addAnimationClass ($animationWraps, wh, ws) {
  $animationWraps.each(function () {
    if (!$(this).hasClass('animation-start')) {
      var elmTop = $(this).offset().top;
      if (elmTop - wh - ws + 50 < 0) {
        $(this).addClass('animation-start');
        var $animationElms = $(this).find('.js-animation_item');
        var l = $animationElms.length;
        var i = 0;
        var timer = setInterval(function () {
          $animationElms.eq(i).addClass('animation-start');
          i++;
          if (i == l) {
            clearInterval(timer);
          }
        }, 200);
      }
    }
  });
}
